import React, { useState, useRef } from 'react'

import { ForestPlotContainer, SingleForestPlot } from 'nswidgets/src/components/forest/forest'
import { Legend } from 'nswidgets/src/common/legend/legend'
import { ControlBar } from '../control-bar'
import { blockDataService } from '../block-data.service'
import { ChartLoader } from '../chart-loader'
import { reportLayoutService } from '../report-layout.service'

import { useStyles } from './forest-block.style'
import { SplitChartFilterBar } from '../split-chart-filter-bar'
import { SideBySideChart } from '../side-by-side-chart'
import { reportDataSetService } from '../../editor/report-data-set.service'
import { SideBySideChartContainer } from '../side-by-side-chart-container'

const DEFAULT_WIDTH = 1024

export const ForestBlock = function ({
  blockKey,
  dataKey,
  data,
  report,
  strataDefinition,
  sliderDefinition,
  filterDefinition,
  parentControlBar,
  parentBlock,
  parentBlockSelections,
  width = DEFAULT_WIDTH,
  splitChart = false,
  ...props
}) {
  const classes = useStyles()

  const rawData = useRef([])
  const [datasets, setDatasets] = useState()
  const [selections, setSelections] = useState()
  const [splitChartSelections, setSplitChartSelections] = useState(
    reportDataSetService.getFilterDefinitionSplitChartSelections(filterDefinition)
  )
  const [propOverrides, setPropOverrides] = useState()

  props = initializeProps(props, propOverrides)

  function initializeProps (props, propOverrides) {
    props = {
      columnNames: props.dataDefinition ? props.dataDefinition : props.columnNames,
      ...props
    }

    return reportLayoutService.applyPropOverrides(props, propOverrides)
  }

  function onDataLoad (data) {
    rawData.current = splitChart ? data : [data]
    updateChart(selections)
  }

  function updateChart (currentSelections) {
    if (rawData.current && rawData.current.length) {
      const datasets = rawData.current.map((data) => {
        return blockDataService.filterBlockDataByKeyValue(data, sliderDefinition && sliderDefinition.key, currentSelections.slider)
      })
      setDatasets(datasets)
    }
  }

  function onControlBarChange (selections, changes) {
    if (changes.props) {
      setPropOverrides(selections.props)
    }

    if (changes.slider) {
      updateChart(selections)
    } else {
      setSelections(selections)
    }
  }

  const missingChartStyles = {
    width: 500,
    height: 400
  }

  return (
    <div className="report-full-width">
      <ControlBar
        className={classes.controlBarContainer}
        strataDefinition={strataDefinition}
        sliderDefinition={sliderDefinition}
        filterDefinition={filterDefinition}
        parentControlBar={parentControlBar}
        parentBlock={parentBlock}
        parentBlockSelections={parentBlockSelections}
        onChange={onControlBarChange} />
      <div className={classes.chartContainer}>
        <ChartLoader report={report} blockKey={blockKey} dataKey={dataKey} sliderDefinition={sliderDefinition} selections={selections} splitChart={splitChart} splitChartSelections={splitChartSelections} width={width} onDataLoad={onDataLoad}>
          <ForestPlotContainer datasets={datasets} {...props}>
            {({ analysesList, labels, colors }) => {
              const showLegend = analysesList && analysesList[0] && !!analysesList.find((analyses) => analyses.length > 1)
              return (
                <>
                  {showLegend && <Legend labels={labels} colors={colors} />}
                  {splitChart && <SplitChartFilterBar filterDefinition={filterDefinition} onChange={setSplitChartSelections} className={classes.sideBySideChartFilterBar} />}
                  {splitChart ? (
                    <SideBySideChartContainer>
                      <div className={classes.sideBySideChart}>
                        <SideBySideChart data={analysesList && analysesList[0] && analysesList[0].length} missingChartStyles={missingChartStyles}>
                          <SingleForestPlot analyses={analysesList[0]} labels={labels} colors={colors} {...props} />
                        </SideBySideChart>
                      </div>
                      <div className={classes.sideBySideChart}>
                        <SideBySideChart data={analysesList && analysesList[1] && analysesList[1].length} missingChartStyles={missingChartStyles}>
                          <SingleForestPlot analyses={analysesList[1]} labels={labels} colors={colors} {...props} />
                        </SideBySideChart>
                      </div>
                    </SideBySideChartContainer>
                  ) : (
                    <SingleForestPlot analyses={analysesList[0]} labels={labels} colors={colors} {...props} />
                  )}
                </>
              )
            }}
          </ForestPlotContainer>
        </ChartLoader>
      </div>
    </div>
  )
}
